import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { MenuEnhancementState, MenuSuggestion } from '../../components/menuEnhancement/types';

const initialState: MenuEnhancementState = {
  suggestions: [],
  totalCount: 0,
  loading: false,
  error: null,
  stats: {
    total: 0,
    combos: 0,
    newItems: 0,
  },
};

const menuEnhancementSlice = createSlice({
  name: 'menuEnhancement',
  initialState,
  reducers: {
    fetchMenuEnhancementRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuEnhancementSuccess: (state, action: PayloadAction<{ suggestions: MenuSuggestion[]; count: number }>) => {
      state.loading = false;
      state.suggestions = action.payload.suggestions;
      state.totalCount = action.payload.count;
      
      // Calculate stats
      state.stats.total = action.payload.count;
      state.stats.combos = action.payload.suggestions.filter(s => 
        s.suggestion_type.toLowerCase().includes('combo')
      ).length;
      state.stats.newItems = action.payload.suggestions.filter(s => 
        s.suggestion_type.toLowerCase().includes('new item')
      ).length;
    },
    fetchMenuEnhancementFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearMenuEnhancement: (state) => {
      state.suggestions = [];
      state.totalCount = 0;
      state.error = null;
      state.stats = { total: 0, combos: 0, newItems: 0 };
    },
  },
});

export const {
  fetchMenuEnhancementRequest,
  fetchMenuEnhancementSuccess,
  fetchMenuEnhancementFailure,
  clearMenuEnhancement,
} = menuEnhancementSlice.actions;

export default menuEnhancementSlice.reducer;
